//
//
//
//
//
//
//
//

export default {
    id: 22,
    version: '3.8.9',
    date: '2023-07-20',
    notify: true,
}
